const EduBoxMobileNav = () => {
  return (
    <div className="web25__edubox-mobile-nav">
      <p>Mobile navi goes here!</p>
    </div>
  );
};

export default EduBoxMobileNav;
